module.exports = "/_next/static/images/466ea310c343a5b95ecb3119852ef424-purple-check.svg";